import React from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

const ContractorPaymentForm = ({
  paymentForm,
  contractors,
  handleChange,
  handleSubmit,
  handleCancel,
}) => {
  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Contractor *</Form.Label>

            <Form.Select
              name="contractor_id"
              value={paymentForm.contractor_id}
              onChange={handleChange}
              required
            >
              <option value="">Select Contractor</option>

              {contractors.map((contractor) => (
                <option key={contractor.id} value={contractor.id}>
                  {contractor.name}
                  {contractor.contact_number
                    ? ` - ${contractor.contact_number}`
                    : ""}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Date *</Form.Label>

            <Form.Control
              type="date"
              name="date"
              value={paymentForm.date}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Amount *</Form.Label>

            <Form.Control
              type="number"
              name="amount"
              value={paymentForm.amount}
              onChange={handleChange}
              placeholder="Enter payment amount"
              min="0.01"
              step="0.01"
              required
            />
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Remarks</Form.Label>

            <Form.Control
              type="text"
              name="remarks"
              value={paymentForm.remarks}
              onChange={handleChange}
              placeholder="Enter remarks"
              maxLength={100}
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>

        <Button type="submit" variant="primary">
          {paymentForm.id ? "Update" : "Add"}
        </Button>
      </div>
    </Form>
  );
};

export default ContractorPaymentForm;